// extracted by mini-css-extract-plugin
export default {"processingMessage":"UploadPhoto_processingMessage__gM5SB","processing":"UploadPhoto_processing__iMQkB","idle":"UploadPhoto_idle__4ndTE"};